var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WpLink',{attrs:{"url":_vm.data.url,"title":_vm.data.title,"target":_vm.data.target},domProps:{"innerHTML":_vm._s(_vm.title)}})
}
var staticRenderFns = []

export { render, staticRenderFns }